import React from "react";
import "../../styles/find-car-form.css";
import "../../styles/find-car-form.css";
import { Form, FormGroup } from "reactstrap";
import { useState } from "react";

const FindCarForm = () => {
  const [formData, setFormData] = useState({ from: '', to: '', date: '', time: '', carType: '' });
  // useEffect(() => {
  //   const submitForm = async () => {
  //     // Perform validation on form data
  //     const { from, to, date, time, carType } = formData;

  //     if (from.trim() === '' || to.trim() === '' || date.trim() === '' || time.trim() === '' || carType.trim() === '') {
  //       alert('Please fill in all fields');
  //       return;
  //     }

  //     // Submit form data to API endpoint
  //     try {
  //       const response = await fetch('https://example.com/api/book-ride', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(formData)
  //       });

  //       if (response.ok) {
  //         alert('Form submitted successfully');
  //         setFormData({
  //           from: '',
  //           to: '',
  //           date: '',
  //           time: '',
  //           carType: ''
  //         }); // Clear form fields on successful submission
  //       } else {
  //         alert('Error submitting form');
  //       }
  //     } catch (error) {
  //       alert('Error submitting form');
  //     }
  //   };

  //   submitForm();
  // }, [formData]);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log('formData', formData);
    
  };
  return (
    <Form className="form" onSubmit={handleSubmit}>
      <div className=" d-flex align-items-center justify-content-between flex-wrap">
        <FormGroup className="form__group">
          <input type="text" placeholder="From address" required name='from' value={formData.from} onChange={handleInputChange} />
        </FormGroup>

        <FormGroup className="form__group"  >
          <input type="text" placeholder="To address" required name='to' value={formData.to} onChange={handleInputChange} />
        </FormGroup>

        <FormGroup className="form__group">
          <input type="date" placeholder="Journey date" required name='date' value={formData.date} onChange={handleInputChange} />
        </FormGroup>

        <FormGroup className="form__group">
          <input
            className="journey__time"
            type="time"
            placeholder="Journey time"
            required
            name='time' value={formData.time} onChange={handleInputChange}
          />
        </FormGroup>
        <FormGroup className="select__group">
          <select name='carType' value={formData.carType} onChange={handleInputChange} >
            <option value="ac">AC Car</option>
            <option value="non-ac">Non AC Car</option>
          </select>
        </FormGroup>
        <FormGroup className="select__group">
          <select name='carType' value={formData.carType} onChange={handleInputChange} >
            <option value="ac">AC Car</option>
            <option value="non-ac">Non AC Car</option>
          </select>
        </FormGroup>

        <FormGroup className="form__group">
          <button type="submit" className="btn btn-warning find__car-btn">Find Car</button>
        </FormGroup>
      </div>
    </Form>
  );
};

export default FindCarForm;
